
























import { Component, Vue } from "vue-property-decorator";
import Headings from "./Styleguide/Headings.vue";
import Buttons from "./Styleguide/Buttons.vue";
import FormControls from "./Styleguide/FormControls.vue";
import Modals from "./Styleguide/Modals.vue";
import Colors from "./Styleguide/Colors.vue";
import QuadrantChart from "@/components/QuadrantChart.vue";
import Charts from "@/views/Styleguide/Charts.vue";

@Component({
  components: {
    Headings,
    Colors,
    Buttons,
    FormControls,
    Modals,
    Charts,
  },

  mounted() {},
})
export default class Styleguide extends Vue {}
